import React from 'react'
import RequestAccessThemed from '_uikit/request-access'

const Index = ({ children }) => {
  return <RequestAccessThemed>{children}</RequestAccessThemed>
}

export default Index
